var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      { staticClass: "svg-icon", attrs: { "aria-hidden": "true" } },
      _vm.$listeners
    ),
    [
      _c("use", {
        attrs: { id: _vm.itemId, "xlink:href": "#icon-" + _vm.name },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }